import style from "./AcknowledgementContent.module.scss";
import classNames from "classnames";
import AcknowledgmentForAppMode from "../../../components/AcknowledgementModal/appMode/AcknowledgmentForAppMode";

const AcknowledgementContent = ({
  onClickCollapseButton,
  doiLink,
  showCollapseButton = false,
  link,
  isOpen,
  showExtraInfo = true,
}) => {
  const handleDoiLink = () => {
    window.open(doiLink, "_blank", "noopener,noreferrer");
  };

  const handleTgLink = () => {
    window.open("https://tg.org.au", "_blank", "noopener,noreferrer");
  };

  return isOpen ? (
    <>
      <div className={style.hideAcknowledgements}>
        <div className={"size-18 semibold"}>Acknowledgements</div>
        {showCollapseButton && (
          <div className={style.pullRight} onClick={onClickCollapseButton}>
            <span className={classNames("size-14", style.hideText)}>Hide</span>
            <button className={style.hideButton}>
              <i className="tg-icons-ChevronUp" />
            </button>
          </div>
        )}
      </div>
      <AcknowledgmentForAppMode link={link} />
      {/* This text were provided and added to the end of Acknowledgement page */}

      {showExtraInfo && (
        <div className={style.extraParagraph}>
          The individuals listed above have provided declarations of interest as per Therapeutic
          Guidelines Limited’s policy on conflict of interest; see the{" "}
          <span className={style.staticLink} data-testid="doi-link" onClick={handleDoiLink}>
            Register of declared interests
          </span>
          . For more information, see the{" "}
          <span className={style.staticLink} data-testid="tg-link" onClick={handleTgLink}>
            Therapeutic Guidelines website
          </span>
          .
        </div>
      )}
    </>
  ) : null;
};

export default AcknowledgementContent;
